import React from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const Banner = () => {
  return (
    <section className="banner-section fix">
      <div className="slider-area">
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          spaceBetween={0}
          slidesPerView={1}
          loop={true}
          speed={1500}
          autoplay={{
            delay: 4000,
            disableOnInteraction: false,
          }}
          className="banner-slider"
        >
          {/* Slide 1 */}
          <SwiperSlide>
            <div
              className="banner-wrapper style1"
              style={{
                backgroundImage: "url('/assets/img/bg/background1.jpg')",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
            >
              <div className="shape1_1 d-none d-xxl-block">
                <img src="assets/img/shape/bannerShape1_1.svg" alt="shape" />
              </div>
              <div className="shape1_2 d-none d-xxl-block">
                <img src="assets/img/shape/bannerShape1_2.svg" alt="shape" />
              </div>
              <div className="shape1_1 d-none d-xxl-block" data-animation="slideInLeft" data-duration="2s" data-delay=".3s">
                <img src="assets/img/shape/bannerShape1_1.svg" alt="shape" />
              </div>
              <div className="shape1_2 d-none d-xxl-block" data-animation="slideInLeft" data-duration="2s" data-delay=".3s">
                <img src="assets/img/shape/bannerShape1_2.svg" alt="shape" />
              </div>
              <div className="shape1_3 d-none d-xxl-block" data-animation="slideInLeft" data-duration="3s" data-delay="2s">
                <img src="assets/img/shape/bannerShape1_3.svg" alt="shape" />
              </div>
              <div className="shape1_4 d-none d-xxl-block" data-animation="slideInLeft" data-duration="2s" data-delay=".3s">
                <img src="assets/img/shape/bannerShape1_4.svg" alt="shape" />
              </div>
              <div className="shape1_5 d-none d-xxl-block" data-animation="slideInLeft" data-duration="2s" data-delay=".3s">
                <img src="assets/img/shape/bannerShape1_5.svg" alt="shape" />
              </div>
              <div className="shape1_6 d-none d-xxl-block cir36">
                <img src="assets/img/shape/bannerShape1_6.svg" alt="shape" />
              </div>
              <div className="overlay"></div>
              <div className="banner-container">
                <div className="container">
                  <div className="row">
                    <div className="col-12 col-xxl-6">
                      <div className="banner-style1">
                        <div className="section-title">
                          <h6 className="sub-title">PREMIUM SERVICE</h6>
                          <h1 className="title">
                            Elevate Your Celebrations with Premium <br />Catering
                          </h1>
                          <a className="theme-btn" href="/menu">
                            View Our Menus <i className="fa-sharp fa-regular fa-arrow-right"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-xl-6 d-none d-xxl-block">
                      <div className="banner-thumb-area">
                        <img src="assets/img/banner/Thali1.png" alt="banner" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>

          {/* Slide 2 */}
          <SwiperSlide>
            <div
              className="banner-wrapper style1"
              style={{ 
                backgroundImage: "url('/assets/img/bg/bg2.png')",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
            >
              <div className="shape1_1 d-none d-xxl-block">
                <img src="assets/img/shape/bannerShape1_1.svg" alt="shape" />
              </div>
              <div className="shape1_2 d-none d-xxl-block">
                <img src="assets/img/shape/bannerShape1_2.svg" alt="shape" />
              </div>
              <div className="shape1_1 d-none d-xxl-block" data-animation="slideInLeft" data-duration="2s" data-delay=".3s">
                <img src="assets/img/shape/bannerShape1_1.svg" alt="shape" />
              </div>
              <div className="shape1_2 d-none d-xxl-block" data-animation="slideInLeft" data-duration="2s" data-delay=".3s">
                <img src="assets/img/shape/bannerShape1_2.svg" alt="shape" />
              </div>
              <div className="shape1_3 d-none d-xxl-block" data-animation="slideInLeft" data-duration="3s" data-delay="2s">
                <img src="assets/img/shape/bannerShape1_3.svg" alt="shape" />
              </div>
              <div className="shape1_4 d-none d-xxl-block" data-animation="slideInLeft" data-duration="2s" data-delay=".3s">
                <img src="assets/img/shape/bannerShape1_4.svg" alt="shape" />
              </div>
              <div className="shape1_5 d-none d-xxl-block" data-animation="slideInLeft" data-duration="2s" data-delay=".3s">
                <img src="assets/img/shape/bannerShape1_5.svg" alt="shape" />
              </div>
              <div className="shape1_6 d-none d-xxl-block cir36">
                <img src="assets/img/shape/bannerShape1_6.svg" alt="shape" />
              </div>
              <div className="overlay"></div>
              <div className="banner-container">
                <div className="container">
                  <div className="row">
                    <div className="col-12 col-xxl-6">
                      <div className="banner-style1">
                        <div className="section-title">
                          <h6 className="sub-title">PREMIUM SERVICE</h6>
                          <h1 className="title">
                            15+ Years of Experience in Catering & Events in All Over Gujarat.
                          </h1>
                          <a className="theme-btn" href="/menu">
                            View Our Menus <i className="fa-sharp fa-regular fa-arrow-right"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-xl-6 d-none d-xxl-block">
                      <div className="banner-thumb-area">
                        {/* <img src="assets/img/banner/b22.png" alt="banner" /> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>

          {/* Slide 3 */}
          <SwiperSlide>
            <div
              className="banner-wrapper style1"
              style={{
                backgroundImage: "url('/assets/img/bg/bg4.png')",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
            >
              <div className="shape1_1 d-none d-xxl-block">
                <img src="assets/img/shape/bannerShape1_1.svg" alt="shape" />
              </div>
              <div className="shape1_2 d-none d-xxl-block">
                <img src="assets/img/shape/bannerShape1_2.svg" alt="shape" />
              </div>
              <div className="shape1_1 d-none d-xxl-block" data-animation="slideInLeft" data-duration="2s" data-delay=".3s">
                <img src="assets/img/shape/bannerShape1_1.svg" alt="shape" />
              </div>
              <div className="shape1_2 d-none d-xxl-block" data-animation="slideInLeft" data-duration="2s" data-delay=".3s">
                <img src="assets/img/shape/bannerShape1_2.svg" alt="shape" />
              </div>
              <div className="shape1_3 d-none d-xxl-block" data-animation="slideInLeft" data-duration="3s" data-delay="2s">
                <img src="assets/img/shape/bannerShape1_3.svg" alt="shape" />
              </div>
              <div className="shape1_4 d-none d-xxl-block" data-animation="slideInLeft" data-duration="2s" data-delay=".3s">
                <img src="assets/img/shape/bannerShape1_4.svg" alt="shape" />
              </div>
              <div className="shape1_5 d-none d-xxl-block" data-animation="slideInLeft" data-duration="2s" data-delay=".3s">
                <img src="assets/img/shape/bannerShape1_5.svg" alt="shape" />
              </div>
              <div className="shape1_6 d-none d-xxl-block cir36">
                <img src="assets/img/shape/bannerShape1_6.svg" alt="shape" />
              </div>
              <div className="overlay"></div>
              <div className="banner-container">
                <div className="container">
                  <div className="row">
                    <div className="col-12 col-xxl-6">
                      <div className="banner-style1">
                        <div className="section-title">
                          <h6 className="sub-title">PREMIUM SERVICE</h6>
                          <h1 className="title">
                            Live Counters <br />to Make Your<br />Event<br />Unforgettable
                          </h1>
                          <a className="theme-btn" href="/menu">
                            View Our Menus <i className="fa-sharp fa-regular fa-arrow-right"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-xl-6 d-none d-xxl-block">
                      <div className="banner-thumb-area">
                        {/* <img src="assets/img/banner/live2.png" alt="banner" /> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>

          <div className="pagination-class swiper-pagination"></div>
        </Swiper>
      </div>
    </section>
  );
};

export default Banner;